import { Component, input, signal } from '@angular/core';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import {
	AddressToStringPipe
} from '@infodocs/portfolio/modals/add-company-modal/company-information-confirmation/address-to-string.pipe';
import { IconComponent } from '@infodocs/shared/components/icon/icon.component';

@Component({
	selector: 'app-company-information-confirmation',
	imports: [
		AddressToStringPipe,
		IconComponent
	],
	templateUrl: './company-information-confirmation.component.html',
	styleUrl: './company-information-confirmation.component.scss'
})
export class CompanyInformationConfirmationComponent {
	public readonly companyDetails = input.required<any>();
	public readonly directorsDetails = input.required<any[]>();
	protected readonly toggleStates = signal<{ [key: string]: boolean }>({
		companySummary: false,
		directorSummary: true
	});
	protected readonly faAngleDownIcon = faAngleDown;
	protected readonly faAngleUpIcon = faAngleUp;

	protected toggleTableBody(key: string): void {
		this.toggleStates.update(state => ({
			...state,
			[key]: !state[key]
		}));
	}
}
